import React from "react";
import { FaEnvelope, FaEnvelopeOpen, FaInbox, FaRegClock } from "react-icons/fa";

import { formatDateTime } from "../utils/messagesSectionUtils";

export default function MessagesStats({ stats }) {
  return (
    <div className="grid gap-3 sm:grid-cols-2 xl:grid-cols-4">
      <MiniStat
        icon={<FaInbox />}
        label="Total"
        value={stats.total}
        helper="Messages reçus"
        accent="indigo"
      />

      <MiniStat
        icon={<FaEnvelope />}
        label="Non lus"
        value={stats.unread}
        helper="À traiter"
        accent="rose"
      />

      <MiniStat
        icon={<FaEnvelopeOpen />}
        label="Lus"
        value={stats.read}
        helper="Déjà consultés"
        accent="emerald"
      />

      <MiniStat
        icon={<FaRegClock />}
        label="Dernier message"
        value={stats.latestDate ? "OK" : "—"}
        helper={stats.latestDate ? formatDateTime(stats.latestDate) : "Aucun message"}
        accent="amber"
      />
    </div>
  );
}

function MiniStat({ icon, label, value, helper, accent = "indigo" }) {
  const accents = {
    indigo:
      "border-indigo-200 bg-indigo-50 text-indigo-700 dark:border-indigo-500/20 dark:bg-indigo-500/10 dark:text-indigo-300",
    emerald:
      "border-emerald-200 bg-emerald-50 text-emerald-700 dark:border-emerald-500/20 dark:bg-emerald-500/10 dark:text-emerald-300",
    amber:
      "border-amber-200 bg-amber-50 text-amber-700 dark:border-amber-500/20 dark:bg-amber-500/10 dark:text-amber-300",
    rose:
      "border-rose-200 bg-rose-50 text-rose-700 dark:border-rose-500/20 dark:bg-rose-500/10 dark:text-rose-300",
  };

  return (
    <div className={`rounded-2xl border px-4 py-3 ${accents[accent]}`}>
      <div className="flex items-center gap-3">
        <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-white/80 dark:bg-slate-900/50">
          {icon}
        </div>

        <div className="min-w-0">
          <p className="text-[11px] font-bold uppercase tracking-[0.16em] opacity-75">
            {label}
          </p>

          <p className="mt-0.5 text-xl font-bold text-slate-950 dark:text-white">
            {typeof value === "number" ? value.toLocaleString("fr-FR") : value}
          </p>

          {helper && (
            <p className="mt-0.5 truncate text-xs text-slate-600 dark:text-slate-300">
              {helper}
            </p>
          )}
        </div>
      </div>
    </div>
  );
}